@if (isVisible) {
  <div class="grid-x screen-only">
    <div class="cell large-12">
      <label>
        <span class="control-label-text" [innerHTML]="componentData.label | safeHtml"></span>
        <textarea [(ngModel)]="noteText" placeholder="Review Note"></textarea>
      </label>
    </div>
  </div>
  <div class="grid-x screen-only">
    <div class="cell large-12">
      <span class="checkbox">
        <input class="show-for-sr no-margin-bottom" type="checkbox" id="isPrivate" [(ngModel)]="noteType">
        <label for="isPrivate" class="inline">
          <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
          <span class="control-label-text">Make Review Note Internal.</span>
        </label>
      </span>
    </div>
  </div>
  <div class="grid-x screen-only">
    <div class="cell large-12">
      <button class="button hollow small" (click)="appendComment($event)" [disabled]="disableAppend">Add Note</button>
    </div>
    @if ((!processingNote$ | async)) {
      <div class="cell large-12">
        {{noteFeedback}}
      </div>
    }
  </div>
}

